var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.742,
    height: 111.889,
    viewBox: "0 0 119.742 111.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.643,40.149a18.1,18.1,0,0,1-6.372-16.4c1-6.857,5.874-8.149,8.363-7.056a3.739,3.739,0,0,1,1.892,4.969c-1.693,3.18-8.164,1.888-9.459-3.578a7.269,7.269,0,0,1,1.195-5.863c1.991-2.683,5.675-3.677,8.961-4.174.7-.1,1.493-.2,2.29-.3,1.792-.2,3.983-.5,6.272-.8",
    fill: "none",
    stroke: "#c0d6ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.763,8.248,74.677,9.64l.5-5.267",
    fill: "#a8c7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.577,1.789l-1.394.8L80.054,11.627,75.872,5.466l-.7-1.093L72.188,0l22.8,1.59Z",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.577,1.789l-1.394.8L75.872,5.466l-.7-1.093L94.988,1.59Z",
    fill: "#a8c7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.824,33.261a1.591,1.591,0,1,0-2.251-.1A1.588,1.588,0,0,0,119.824,33.261Z",
    fill: "#eaeef9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.859,82.783v27.329c-.2.1-.4.1-.6.2a55.58,55.58,0,0,1-7.069,1.391V82.783Z",
    fill: "#4988fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.859,82.783v27.329c-.2.1-.4.1-.6.2a55.58,55.58,0,0,1-7.069,1.391V82.783Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.928,82.783v24.149a9.988,9.988,0,0,1-1.493.695l-.6.3h-.1c-.2.1-.5.2-.7.3a37.534,37.534,0,0,1-4.68,1.689V82.783Z",
    fill: "#2767f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.928,82.783v24.149a9.988,9.988,0,0,1-1.493.695l-.6.3h-.1c-.2.1-.5.2-.7.3a37.534,37.534,0,0,1-4.68,1.689V82.783Z",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.928,82.783H71.192v8.547H85.928Z",
    fill: "#a8c7ff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.191,52.571V83.18H93.3v.1H45.405V28.323h45.5a11.452,11.452,0,0,1,1.892-.1,17.654,17.654,0,0,1,2.29.1,23.536,23.536,0,0,1,2.788.4,25.042,25.042,0,0,1,12.146,6.559A24.4,24.4,0,0,1,117.191,52.571Z",
    fill: "#cfae26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.174,59.031A5.466,5.466,0,1,0,92.7,53.565,5.47,5.47,0,0,0,98.174,59.031Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.863,48.7a5.561,5.561,0,0,1,2.887,4.869,5.476,5.476,0,0,1-10.952,0,5.62,5.62,0,0,1,1.294-3.578",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2,50.186V83.28H20.415V50.186A21.962,21.962,0,0,1,37.54,28.82a19.84,19.84,0,0,1,4.879-.5H47.4A21.948,21.948,0,0,1,69.1,46.807C69.1,47.8,69.2,48.994,69.2,50.186Z",
    fill: "#ba9c21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.979,27.031h2.788V53.367a1.394,1.394,0,0,1-2.788,0V32.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.979,27.031h2.788V53.367a1.394,1.394,0,0,1-2.788,0V32.4",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.71,26.634a.563.563,0,0,1-.4.994H96.382V16.8h15.93a.573.573,0,0,1,.4.994l-4.181,3.478a1.218,1.218,0,0,0,0,1.888Z",
    fill: "#ea67a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.859,110.112h.2c-.1,0-.3.1-.4.1C78.66,110.112,78.759,110.112,78.859,110.112Z",
    fill: "#d5dae8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.158,110.013c.1,0,.1,0,.2-.1-.1,0-.3.1-.4.1Z",
    fill: "#d5dae8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.842,110.211c-.2.5-.3.994-.5,1.491",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2,46.708A22.248,22.248,0,0,0,47.3,28.224H42.319a26.2,26.2,0,0,0-4.879.5A22.346,22.346,0,0,0,22.008,41.54a4.255,4.255,0,0,1,1.792-.4A20.663,20.663,0,0,1,37.739,30.112a22.1,22.1,0,0,1,4.48-.5H47.2A20.351,20.351,0,0,1,67.409,46.807a16.421,16.421,0,0,1,.3,3.18v31.6h-45.8V72.845a4.379,4.379,0,0,1-1.493-.2V83.081H69.5V50.186A19.671,19.671,0,0,0,69.2,46.708Z",
    fill: "#d3ba52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5,79.8V83.28H2.792A1.765,1.765,0,0,1,1,81.59,1.783,1.783,0,0,1,2.792,79.8Z",
    fill: "#cfae26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.415,73.342V79.9H2.892A1.783,1.783,0,0,0,1.1,81.689a1.7,1.7,0,0,0,1.792,1.689H93.3v-.1h23.9V52.571A24.323,24.323,0,0,0,97.876,28.82a26.883,26.883,0,0,0-2.788-.4,17.655,17.655,0,0,0-2.29-.1,12.715,12.715,0,0,0-1.892.1H48.791c-.5,0-1-.1-1.493-.1H42.319a26.2,26.2,0,0,0-4.879.5A21.968,21.968,0,0,0,22.506,40.646",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.435,69.267a3.778,3.778,0,0,1-3.783,3.776c-39.029,0-36.54.2-37.834-.6a3.8,3.8,0,0,1-1.792-3.18c2.29-25.938,1.892-25.64,3.485-27.13,1.493-1.292-.6-.895,38.233-.895a4.06,4.06,0,0,1,2.987,1.391C64.024,44.323,63.725,43.727,61.435,69.267Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.128,43.23c-.2.2-.4.3-.6.5-19.116,16.2-18.718,16.5-21.506,16.5-2.887,0-2.788-.3-16.03-12.919",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.435,69.267a3.778,3.778,0,0,1-3.783,3.776c-39.029,0-36.54.2-37.834-.6a3.8,3.8,0,0,1-1.792-3.18c2.29-25.938,1.892-25.64,3.485-27.13,1.493-1.292-.6-.895,38.233-.895a4.06,4.06,0,0,1,2.987,1.391C64.024,44.323,63.725,43.727,61.435,69.267Z",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.636,48.7H2.692a1.093,1.093,0,1,1,0-2.186H15.636a1.093,1.093,0,1,1,0,2.186Z",
    fill: "#ea67a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.038,54.857H7.571a1.093,1.093,0,1,1,0-2.186h7.467a1.093,1.093,0,1,1,0,2.186Z",
    fill: "#ea67a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.341,60.72H10.16a1.093,1.093,0,1,1,0-2.186h4.281a1.1,1.1,0,0,1,1.1,1.093A1.129,1.129,0,0,1,14.341,60.72Z",
    fill: "#ea67a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,60.422h-4.48a.47.47,0,0,0-.5.5l-.1.6c-1.1.6-1.792.2-2.688-.2s-1.991-.894-3.087.3a.707.707,0,0,0,1.1.894c.3-.4.5-.4,1.394.1a4.738,4.738,0,0,0,2.19.6,2.761,2.761,0,0,0,.9-.1l-.1,1.093a2.484,2.484,0,0,1-2.19-.4c-.9-.4-1.991-.894-2.987.3a.707.707,0,0,0,1.1.894c.3-.3.5-.3,1.394.1a4.739,4.739,0,0,0,2.19.6h.5a.661.661,0,0,0,.5.4h4.48a.47.47,0,0,0,.5-.5l.6-4.472C56.357,60.72,56.158,60.422,55.76,60.422Zm-1.1,4.075a.318.318,0,0,1-.3.3H51.877a.318.318,0,0,1-.3-.3l.1-.8.1-1.093.1-.5a.318.318,0,0,1,.3-.3h2.489a.318.318,0,0,1,.3.3Z",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.708,50.683V79.8H27.882",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.193,83.975V107.23",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.929,90.335v-6.36",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSent);
export default __webpack_public_path__ + "static/media/mail-sent.677d99b2aa4566d99ad0481c10d4c908.svg";
export { ForwardRef as ReactComponent };